export interface ColumnDescriptor<T> {
  id: keyof T;
  headerRenderer: () => React.ReactNode;
  cellRenderer: (record: any) => React.ReactNode;
  width?: number;
}

export interface TableColValue {
  id: string;
  label: string;
  type: string;
  width?: number;
}

export enum ColumnType {
  DEFAULT = 'default',
  PERSON = 'person',
  GREEN_TEXT = 'greenText',
  DATE = 'date',
}
